module.exports = __webpack_public_path__ + "static/media/mcqMomentDiagram3.06084c92.svg";